import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "search-results" }
const _hoisted_2 = { class: "search-results__list" }
const _hoisted_3 = ["href"]
const _hoisted_4 = { class: "search-results__title" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "search-results__details" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "search-results__title" }
const _hoisted_11 = { class: "search-results__details" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_arrow_right = _resolveComponent("arrow-right")!
  const _component_arrow_down = _resolveComponent("arrow-down")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_loader, {
          key: 0,
          "is-loading": _ctx.isLoading
        }, null, 8, ["is-loading"]))
      : _createCommentVNode("", true),
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchResults, (searchResult, index) => {
        return (_openBlock(), _createElementBlock("li", {
          class: "search-results__item",
          key: index
        }, [
          _createElementVNode("a", {
            href: _ctx.searchResultLink(searchResult.url),
            class: "search-results__link"
          }, [
            _createElementVNode("h3", _hoisted_4, [
              (searchResult.title)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(searchResult.title), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(searchResult.name), 1)),
              _createVNode(_component_arrow_right)
            ]),
            _createElementVNode("div", _hoisted_7, _toDisplayString(searchResult.abstract), 1)
          ], 8, _hoisted_3)
        ]))
      }), 128)),
      (_ctx.searchResults.length === 0 && !_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
            _createElementVNode("a", {
              href: _ctx.noResultLink,
              class: "search-results__link"
            }, [
              _createElementVNode("h3", _hoisted_10, [
                _createTextVNode(_toDisplayString(_ctx.noResultTitle) + " ", 1),
                _createVNode(_component_arrow_right)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("span", null, _toDisplayString(_ctx.noResultAbstract), 1)
              ])
            ], 8, _hoisted_9)
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.searchResults.length < _ctx.totalItems)
      ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          class: "search-results__load-more",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('loadMore')), ["prevent"]))
        }, [
          _createTextVNode(_toDisplayString(_ctx.$t('finder.loadMore')) + " ", 1),
          _createVNode(_component_arrow_down)
        ]))
      : _createCommentVNode("", true)
  ]))
}